import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vant from 'vant';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'vant/lib/index.css';
import { serve,emails,https,hscp } from '@/api/uesr'
import VueI18n from 'vue-i18n'

import  Footer from '@/components/footer'
import cn  from './lang/chinese'    // 引入lang文件
import  en from './lang/english'

import ar  from './lang/ar'    // 引入lang文件
import  de from './lang/de'

import es  from './lang/es'    // 引入lang文件
import  fr from './lang/fr'

import hi  from './lang/hi'    // 引入lang文件
import  ko from './lang/ko'

import pt  from './lang/pt'    // 引入lang文件
import  ru from './lang/ru'

import  tw from './lang/tw'

import md5 from 'md5'

import { Overlay } from 'vant';
Vue.use(Overlay);
import { List } from 'vant';
Vue.use(List);
import { TreeSelect,Calendar } from 'vant';
import { Tree } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Calendar);
Vue.use(Tree);
Vue.use(ElementUI);

Vue.use(TreeSelect);
Vue.use(VueI18n)  
Vue.component("Footer",Footer)
const i18n = new VueI18n({
  locale: 'cn',   // 设置语言
  messages: {
    cn:{
      ...cn,
    } ,
    tw:{
      ...tw,
    } ,
    en:  {
      ...en ,
    },

    ar:{
      ...ar,
    } ,
    de:  {
      ...de ,
    },
    es:{
      ...es,
    } ,
    fr:  {
      ...fr ,
    },
    hi:{
      ...hi,
    } ,
    ko:  {
      ...ko ,
    },
    pt:{
      ...pt,
    } ,
    ru:  {
      ...ru ,
    }
  }
})
initLocalLang()
function initLocalLang () {
  // element-ui组件国际化
  Vue.use(Vant, {
    i18n: (key, value) => i18n.t(key, value)
  })
}

// Vue.prototype.$plusExtends = fn => {
//   if (window.plus) {
//     setTimeout(fn, 0)
//   } else {
//     document.addEventListener('plusready', fn, false)
//   }
// }

// console.log($plusExtends)


Vue.prototype.$md5 = md5
Vue.prototype.$serve = serve
Vue.prototype.$https = https
Vue.prototype.$email = emails
Vue.prototype.$hscp = hscp
Vue.config.productionTip = false
Vue.use(Vant);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
